// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectionBox_selectionBox__hi7cJ {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0.5rem;
  gap: 0.5rem;
  border-radius: 4px;
  background-color: #E5E5E5;
  align-content: start;
}
@media (max-width: 768px) {
  .SelectionBox_selectionBox__hi7cJ {
    grid-template-columns: 1fr;
  }
}

.SelectionBox_divider__5C-lD {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  margin: 0.5rem 0;
}
.SelectionBox_divider__5C-lD:hover .SelectionBox_dividerText__xXua9 {
  color: #333;
}
.SelectionBox_divider__5C-lD:hover hr {
  background-color: #666;
}
.SelectionBox_divider__5C-lD:hover i {
  color: #333;
}
.SelectionBox_divider__5C-lD .SelectionBox_dividerText__xXua9 {
  white-space: nowrap;
  color: #666;
}
.SelectionBox_divider__5C-lD i {
  color: #777;
}

.SelectionBox_hiddenItems__2f2PF {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .SelectionBox_hiddenItems__2f2PF {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ReportConfigurator/SelectionBox.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;AACF;AACE;EATF;IAUI,0BAAA;EAEF;AACF;;AACA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAEF;AACI;EACE,WAAA;AACN;AAEI;EACE,sBAAA;AAAN;AAGI;EACE,WAAA;AADN;AAKE;EACE,mBAAA;EACA,WAAA;AAHJ;AAME;EACE,WAAA;AAJJ;;AAQA;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;AALF;AAOE;EANF;IAOI,0BAAA;EAJF;AACF","sourcesContent":[".selectionBox {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  padding: 0.5rem;\n  gap: 0.5rem;\n  border-radius: 4px;\n  background-color: #E5E5E5;\n  align-content: start;\n}\n@media (max-width: 768px) {\n  .selectionBox {\n    grid-template-columns: 1fr;\n  }\n}\n\n.divider {\n  grid-column: 1/-1;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  margin: 0.5rem 0;\n}\n.divider:hover .dividerText {\n  color: #333;\n}\n.divider:hover hr {\n  background-color: #666;\n}\n.divider:hover i {\n  color: #333;\n}\n.divider .dividerText {\n  white-space: nowrap;\n  color: #666;\n}\n.divider i {\n  color: #777;\n}\n\n.hiddenItems {\n  grid-column: 1/-1;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.5rem;\n}\n@media (max-width: 768px) {\n  .hiddenItems {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectionBox": `SelectionBox_selectionBox__hi7cJ`,
	"divider": `SelectionBox_divider__5C-lD`,
	"dividerText": `SelectionBox_dividerText__xXua9`,
	"hiddenItems": `SelectionBox_hiddenItems__2f2PF`
};
export default ___CSS_LOADER_EXPORT___;
